import { inject, Injectable } from '@angular/core';
import { Dialog } from '@angular/cdk/dialog';
import { EventTrackerService, TimelineSegmentItem } from '@splixer/player';
import { TrackCardDialog } from '../shared/playback/track-cards/dialog/track-card.dialog';
import { KexpSteeringWheelDialog } from '../shared/playback/steering-wheel/steering-wheel.dialog';
import { SteeringMode } from '@splixer/common';
import { nString } from '@hidat/huijs-common';
import { KexpGreetingDialog } from '../shared/home/greeting/greeting.dialog';

export interface TrackDialogData {
  segmentItem: TimelineSegmentItem;
}

export interface SteeringDialogData {
  steeringMode: SteeringMode;
}

@Injectable({ providedIn: 'root' })
export class KexpDialogsService {
  protected dialog = inject(Dialog);
  protected eventTracker = inject(EventTrackerService);

  public showTrackInfoDialog(np: TimelineSegmentItem, eventSource: nString) {
    const dialogData: TrackDialogData = {
      segmentItem: np,
    };
    const dialogRef = this.dialog.open<string>(TrackCardDialog, {
      width: '30rem',
      data: dialogData,
    });

    dialogRef.closed.subscribe((result) => {
      console.log('The dialog was closed');
    });
    if (eventSource !== null) {
      this.eventTracker.trackEventWithSource('play_detail_open');
    }
  }

  public showSteeringWheel(steeringMode = SteeringMode.UpNext) {
    const dialogData: SteeringDialogData = {
      steeringMode,
    };
    const dialogRef = this.dialog.open<string>(KexpSteeringWheelDialog, {
      width: '30rem',
      data: dialogData,
    });

    dialogRef.closed.subscribe((result) => {
      console.log('The dialog was closed');
    });
  }

  public showGreeting() {
    const dialogRef = this.dialog.open<string>(KexpGreetingDialog, {
      width: '36rem',
    });

    dialogRef.closed.subscribe((result) => {
      console.log('The dialog was closed');
    });
  }
}
